// Shared transport only. Payment price validation and countdown sessions remain separate.
export function createPaymentDiscountClient({wall=()=>Date.now(),mono=()=>performance.now(),schedule=setTimeout,cancel=clearTimeout}={}) {
    let pending=null,recent=null;
    function request({fetcher=fetch,maxAgeMs=0}={}) {
        if(pending&&pending.fetcher===fetcher)return pending.promise;
        if(recent&&recent.fetcher===fetcher&&maxAgeMs>0&&
            wall()>=recent.result.receivedWall&&mono()>=recent.result.receivedAt&&
            Math.max(wall()-recent.result.receivedWall,mono()-recent.result.receivedAt)<maxAgeMs)
            return Promise.resolve(recent.result);
        const job={fetcher,startedAt:mono(),startedWall:wall()};
        const controller=typeof AbortController==='undefined'?null:new AbortController();
        let timeout;
        const deadline=new Promise((_,reject)=>{
            timeout=schedule(()=>{
                reject(new Error('Discount request timed out'));
                if(controller)controller.abort();
            },5000);
        });
        job.promise=Promise.race([
            Promise.resolve().then(()=>fetcher('https://cms.opcms.org/api/payment-discount',{
                credentials:'omit',cache:'no-store',...(controller?{signal:controller.signal}:{})
            })).then(response=>{
                if(!response.ok)throw new Error('Discount request failed');
                return response.json();
            }),deadline
        ]).then(value=>{
            const result={value,startedAt:job.startedAt,startedWall:job.startedWall,receivedAt:mono(),receivedWall:wall()};
            recent={fetcher,result};return result;
        }).finally(()=>{
            cancel(timeout);
            if(pending===job)pending=null;
        });
        pending=job;return job.promise;
    }
    return {request};
}
const client=createPaymentDiscountClient();
export const requestPaymentDiscount=options=>client.request(options);
